/**
 * Haptic feedback for touch interactions, in the spirit of iOS
 * UIImpactFeedbackGenerator. Uses the Vibration API where available
 * (Android/Chrome); silently no-ops elsewhere (iOS Safari has no web
 * vibration API), so it is always safe to call.
 */

type Impact = "light" | "medium" | "heavy" | "success";

const PATTERNS: Record<Impact, number | number[]> = {
  light: 10,
  medium: 20,
  heavy: 35,
  // Two quick pulses — the "it worked" confirmation (keep, save, publish).
  success: [12, 60, 12],
};

export function haptic(impact: Impact = "light") {
  try {
    navigator.vibrate?.(PATTERNS[impact]);
  } catch {
    /* not supported — fine */
  }
}
